import React, { Component } from "react";

import { observer, inject } from "mobx-react";

class StripeHelp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }

  componentDidMount() {

  }


  render() {
    return (
      <div>
        <h1>Stripe Setup Help</h1>
        <h3>1. Go to your stripe.com account</h3>

        <h3>2. Navigate to Settings page</h3>
        <img style={{ width: '100%' }} src="/images/stripe/stripe_1.jpg" alt="Stripe" />

        <h3>3. Navigate to Business page</h3>
        <img style={{ width: '100%' }} src="/images/stripe/stripe_0_1.jpg" alt="Stripe" />
        <h3>and copy &#34;Stripe Account ID&#34;</h3>
        <img style={{ width: '100%' }} src="/images/stripe/stripe_0_2.jpg" alt="Stripe" />

        <h3>4. Navigate to Developers</h3>
        <img style={{ width: '100%' }} src="/images/stripe/stripe_2.jpg" alt="Stripe" />

        <h3>5. Click on &#34;Manage API keys&#34;</h3>
        <img style={{ width: '100%' }} src="/images/stripe/stripe_3.jpg" alt="Stripe" />

        <h3>6. Here you can find and copy &#34;Publishable key&#34;</h3>
        <img style={{ width: '100%' }} src="/images/stripe/stripe_4.jpg" alt="Stripe" />

        <h3>7. And create and copy &#34;Secret key&#34;</h3>
        <img style={{ width: '100%' }} src="/images/stripe/stripe_5.jpg" alt="Stripe" />
        <img style={{ width: '100%' }} src="/images/stripe/stripe_6.jpg" alt="Stripe" />

        <h3>9. Now we need to setup WEBHOOK. Copy URL from school page. FOR EACH SCHOOL URL is DIFFERENT!!!</h3>
        <h3>10. Navigate to &#34;Webhooks&#34;</h3>
        <img style={{ width: '100%' }} src="/images/stripe/stripe_8_1.jpg" alt="Stripe" />
        <img style={{ width: '100%' }} src="/images/stripe/stripe_8_2.jpg" alt="Stripe" />

        <h3>11. Click on button &#34;Add destination&#34;</h3>
        <img style={{ width: '100%' }} src="/images/stripe/stripe_8_3.jpg" alt="Stripe" />

        <h3>12. Select needed events one by one and click &#34;Continue&#34;</h3>
        <img style={{ width: '100%' }} src="/images/stripe/stripe_8_4.jpg" alt="Stripe" />
        <h3>we need only this events:</h3>
        <ul>
          <li>charge.pending</li>
          <li>charge.succeeded</li>
          <li>charge.refunded</li>
          <li>charge.failed</li>
          <li>payment_method.attached</li>
          <li>payment_method.detached</li>
          <li>customer.updated</li>
          <li>invoice.payment_succeeded</li>
          <li>invoice.payment_failed</li>
        </ul>

        <h3>13. Then</h3>
        <img style={{ width: '100%' }} src="/images/stripe/stripe_8_5.jpg" alt="Stripe" />

        <h3>13. Take WEBHOOK URL from school page and fill &#34;Endpoint URL&#34; field and click &#34;Create destination&#34;. <br/>FOR EACH SCHOOL URL is DIFFERENT!!!</h3>
        <img style={{ width: '100%' }} src="/images/stripe/stripe_8_6.jpg" alt="Stripe" />

        <h3>11. Copy WEBHOOK Secret</h3>
        <img style={{ width: '100%' }} src="/images/stripe/stripe_8_7.jpg" alt="Stripe" />

        <h3>15. You have all 4 fields to complete school Stripe integration. Save now and test. Then you can move you STRIPE account in LIVE mode.</h3>

      </div>
    );
  }
}

export default inject("Auth")(observer(StripeHelp))
